import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import CreatePage from "@/pages/CreatePage";
import ColourPicker from "@/pages/ColourPicker";
import ColourStudio from "@/pages/ColourStudio";
import Library from "@/pages/Library";
import Packets from "@/pages/Packets";
import Credits from "@/pages/Credits";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import SharedArtwork from "@/pages/SharedArtwork";
import SharedGallery from "@/pages/SharedGallery";
import LegalPage from "@/pages/LegalPage";
import SafetyPage from "@/pages/SafetyPage";
import { Footer } from "@/components/Footer";
import { HueyHelper } from "@/components/HueyHelper";

const Shell = () => (
  <div className="grain min-h-[100dvh] flex flex-col">
    <Header />
    <main className="relative z-10 flex-1">
      <Outlet />
    </main>
    <Footer />
    <HueyHelper />
  </div>
);

const Home = () => {
  const { user } = useAuth();
  if (user) return <Navigate to="/create" replace />;
  return <Landing />;
};

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Shell />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/signup" element={<AuthPage mode="signup" />} />
              <Route path="/create" element={<P><CreatePage /></P>} />
              <Route path="/colour" element={<P><ColourPicker /></P>} />
              <Route path="/library" element={<P><Library /></P>} />
              <Route path="/packets" element={<P><Packets /></P>} />
              <Route path="/credits" element={<P><Credits /></P>} />
              <Route path="/payment/success" element={<P><PaymentSuccess /></P>} />
              <Route path="/payment/cancel" element={<P><PaymentCancel /></P>} />
              <Route path="/privacy" element={<LegalPage kind="privacy" />} />
              <Route path="/safety" element={<SafetyPage />} />
              <Route path="/terms" element={<LegalPage kind="terms" />} />
              <Route path="/refunds" element={<LegalPage kind="refunds" />} />
            </Route>
            <Route path="/colour/:pageId" element={<P><ColourStudio /></P>} />
            <Route path="/share/:token" element={<SharedArtwork />} />
            <Route path="/gallery/:token" element={<SharedGallery />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
